module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-none element-without-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("MY AUTHOR MOTHER")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container verse without-attribution"
  }, [_c('blockquote', {
    staticClass: "verse without-attribution"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("My mother’s eyes are a deep turquoise-blue")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("They glisten and sparkle like crisp morning dew")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Her face has a beauty that is timeless and bold")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("She has seen many years, but she’ll never look old")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Her mind is a garden of childlike delight")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Where magical creatures live and take flight")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Iridescent fairies with gossamer wings")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Pearlescent unicorns and fanciful things")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Inhabit a world filled with fluorescent flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Where songbirds serenade pink bunnies for hours")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("And sweet honey flows from gold combs in the trees")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Made for the populace by purple-green bees")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Waterfalls rain into luminous streams")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Where willow trees weep for a mermaid’s dreams")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("All of the wonders the author’s mind can see")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("She records in her stories for you and me.")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("Soon her fairytales will entrance one and all")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-content blockquote-content-verse"
  }, [_c('i', [_vm._v("And then she will dance at the Fairy Queen’s Ball.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0d7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 69
// module chunks = 0